// Itens do carrinho no formato que `POST /api/coupons/validate` entende.
//
// Regra do dono (04/10/2026, achado 411): produto em promoção marcada "não aceita
// cupom" fica fora da conta do cupom em todo lugar. Quem decide quais itens
// entram é o SERVIDOR (a mesma conta que grava o pedido): a tela só manda o
// carrinho e o módulo, e mostra o desconto que voltou.
export function itensDoCupom(cart, preco = (i) => i.final_price || i.sale_price) {
  return (cart || []).map((i) => ({
    id: i.product_id || i.id || null,
    nome: i.name || i.nome || "",
    preco: Number(preco(i)) || 0,
    quantidade: Number(i.quantity ?? i.quantidade ?? 1) || 1,
    oferta_chave: i.oferta_chave || undefined,
  }));
}

// "O cupom não vale para X (promoção que não aceita cupom)." — vem do servidor
// quando algum item ficou fora da conta. Vazio no caso comum.
export function avisoDoCupom(resposta) {
  return resposta?.note || "";
}
